// Entry point for the build script in your package.json

import Rails from "@rails/ujs";
Rails.start();

// Grid overlay
import gridOverlay from "./lib/gridOverlay";
gridOverlay();

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);

// Stimulus
import { Application } from "stimulus";
import HeaderController from "./controllers/HeaderController";
const application = Application.start();
application.register("header", HeaderController);
